import styled from "styled-components";
import Video from "../Video/Video";
import Image from "../Image/Image";
import { ReactComponent as RateSvg } from "../../assets/icons/rate.svg";

export const ItemCard = styled.div`
  border-radius: 6px;
  overflow: clip;
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  touch-action: manipulation;
`;

export const PinBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 30;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  pointer-events: none;

  svg {
    width: 18px;
    height: 18px;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.55));
  }

  @media (max-width: 768px) {
    top: 6px;
    right: 6px;
    width: 18px;
    height: 18px;

    svg {
      width: 15px;
      height: 15px;
    }
  }
`;

export const RateContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  top: 6px;
  z-index: 5;
  right: 6px;
`;

export const RateNumber = styled.span`
  color: #fff;
  font-family: Figtree;
  font-weight: 600;
  letter-spacing: -0.049px;
  font-size: 14px;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const RateIcon = styled(RateSvg)`
  width: 14px;
  height: 14px;
  @media (max-width: 768px) {
    width: 10px;
    height: 10px;
  }
`;

export const ThumbnailImageSmall = styled.img`
  position: absolute;
  top: 6px;
  left: 6px;

  z-index: 25;
  border-radius: 6px;
  object-fit: cover;
  transition:
    transform 0.3s ease,
    opacity 0.2s ease;
  width: 64px;
  height: 80px;
  transform: rotate(-6.016deg);
  opacity: ${(props) => (props.$loaded ? 1 : 0)};

  /* NOVO: Optimizacije */
  will-change: transform;
  backface-visibility: hidden;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-drag: none;

  @media (max-width: 768px) {
    width: 45px;
    height: 56px;
    border-radius: 4px;
  }
`;

export const DoubleThumbContainer = styled.div`
  position: absolute;
  top: ${(p) =>
    p.$index === 3 ? "154px" : p.$index === 2 ? "80px" : "6px"};
  left: 6px;
  z-index: ${(p) => (p.$index === 3 ? 27 : p.$index === 2 ? 26 : 25)};
  width: 50px;
  height: 62px;
  border-radius: 6px;
  transform: rotate(-6deg);
  pointer-events: none;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.35));

  @media (max-width: 768px) {
    width: 36px;
    height: 45px;
    top: ${(p) =>
      p.$index === 3 ? "104px" : p.$index === 2 ? "55px" : "6px"};
    border-radius: 4px;
  }
`;

export const DoubleThumbImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: cover;
  display: block;
  opacity: ${(p) => (p.$loaded ? 1 : 0)};
  transition: opacity 0.2s ease;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
`;

export const DoubleThumbBadge = styled.span`
  position: absolute;
  bottom: -4px;
  left: -4px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: #2877d9;
  color: #fff;

  font-family: Figtree;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    min-width: 12px;
    height: 12px;
    font-size: 8px;
    /* bottom: 3px; */
    /* left: 3px; */
    padding: 0 3px;
  }
`;

export const ThumbnailSkeleton = styled.div`
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 24;
  border-radius: 6px;
  width: 64px;
  height: 80px;
  transform: rotate(-6.016deg);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.06) 0%,
    rgba(255, 255, 255, 0.14) 50%,
    rgba(255, 255, 255, 0.06) 100%
  );
  background-size: 200% 100%;
  animation: thumbnailShimmer 1.2s ease-in-out infinite;
  pointer-events: none;

  @keyframes thumbnailShimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  @media (max-width: 768px) {
    width: 45px;
    height: 56px;
    border-radius: 4px;
  }
`;

export const DoubleThumbSkeleton = styled.div`
  position: absolute;
  top: ${(p) =>
    p.$index === 3 ? "154px" : p.$index === 2 ? "80px" : "6px"};
  left: 6px;
  z-index: ${(p) => (p.$index === 3 ? 27 : p.$index === 2 ? 26 : 25)};
  width: 50px;
  height: 62px;
  border-radius: 6px;
  transform: rotate(-6deg);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.06) 0%,
    rgba(255, 255, 255, 0.14) 50%,
    rgba(255, 255, 255, 0.06) 100%
  );
  background-size: 200% 100%;
  animation: thumbnailShimmer 1.2s ease-in-out infinite;
  pointer-events: none;

  @keyframes thumbnailShimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 45px;
    top: ${(p) =>
      p.$index === 3 ? "104px" : p.$index === 2 ? "55px" : "6px"};
    left: 6px;
    border-radius: 4px;
  }
`;
export const StyledVideo = styled(Video)`
  aspect-ratio: unset;
  height: 100%;
  pointer-events: none;

  img,
  video {
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-drag: none;
  }
`;

export const StyledImage = styled(Image)`
  aspect-ratio: unset;
  height: 100%;
  pointer-events: none;

  img {
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-drag: none;
  }
`;

export const Badge = styled.span`
  border-radius: 100px;
  background: ${(props) => {
    if (props.$variant === "Free Trial") {
      return "linear-gradient(90deg, #2D72C7 0%, #2A7DE4 100%)";
    } else if (props.$variant === "Popular") {
      return "linear-gradient(90deg, #D2124F 0%, #FAA835 100%)";
    } else if (props.$variant === "New") {
      return "linear-gradient(90deg, #85CAA8 0%, #7CB398 100%)";
    } else if (props.$variant === "BLEND") {
      return "linear-gradient(270deg, #7CB398 0%, #007ECC 50.48%, #2671CF 100%)";
    } else if (props.$variant === "Trending") {
      return "linear-gradient(180deg, #1F6BAF 0%, #0D1C33 100%)";
    } else if (props.$variant === "Santa's Special") {
      return "linear-gradient(90deg, #82131A 0%, #C02F3C 56.25%, #5A161C 100%)";
    } else if (props.$variant === "VIP") {
      return "linear-gradient(270deg, #A341E4 0%, #24073D 100%)";
    } else if (props.$variant === "8s") {
      return "#0D2E5E";
    } else if (props.$variant === "4K") {
      return "#D7E9FF";
    }

    return "linear-gradient(90deg, #2877D9 0%, #153F73 100%)";
  }};

  border: ${(props) => {
    if (props.$variant === "Free Trial") {
      return "0.5px solid #2876D7";
    } else if (props.$variant === "New") {
      return "0.5px solid #8DD1AA";
    } else if (props.$variant === "Popular") {
      return "0.5px solid #E55943";
    } else if (props.$variant === "Santa's Special") {
      return "none";
    } else if (props.$variant === "VIP") {
      return "0.5px solid #760EA2;";
    } else if (props.$variant === "8s") {
      return "0.5px solid #0D2E5E;";
    } else if (props.$variant === "4K") {
      return "#D7E9FF";
    } else if (props.$variant === "BLEND") {
      return "#007ECC";
    }
    return "0.5px solid #2876D7";
  }};

  display: flex;
  padding: ${(props) =>
    props.$isMobile ? "4px 9px 4px 9px" : "3px 12px 1px 12px"};

  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 4px;
  color: ${(props) => {
    if (props.$variant === "4K") {
      return "#072E61";
    }
    return "#fff";
  }};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.1px;
  /* line-height: 16px; */

  height: ${(props) => (props.$isMobile ? "unset" : "30px")};
`;

export const Username = styled.div`
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.05px;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ModelName = styled.h3`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 18px;
  line-height: 20px;
  font-weight: 700;
  margin-bottom: -5px;
  letter-spacing: -0.1px;
`;

export const VideoFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  color: white;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.01) 80.05%,
    rgba(0, 0, 0, 0.7) 100%
  );
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 10;

  & > * {
    opacity: ${(props) => (props.$hideContent ? "0" : "1")};
    transform: translateY(${(props) => (props.$hideContent ? "20px" : "0")});
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

export const GenerateButton = styled.button`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, ${(props) => (props.$show ? "0" : "80px")});
  color: #333;
  border: none;
  cursor: pointer;
  opacity: ${(props) => (props.$show ? "1" : "0")};
  pointer-events: ${(props) => (props.$show ? "auto" : "none")};
  transition:
    transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.2s ease;
  will-change: transform, opacity;
  z-index: 20;

  border-radius: 100px;
  background: #fff;

  display: flex;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  color: #0f2c32;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.08px;

  &:hover {
    transform: translate(-50%, 0) scale(1.05);
  }

  &:active {
    transform: translate(-50%, 0) scale(0.98);
  }
`;

export const RunningText = styled.div`
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .running-title {
    color: #fff;
    text-align: center;
    font-family: Figtree;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.09px;
  }

  .running-message {
    color: #fff;
    text-align: center;
    font-family: Figtree;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: -0.07px;
  }
`;

export const LoadingSpinnerBlur = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: ${(props) => (props.$show ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(23.1px);
  gap: 12px;

  l-line-spinner {
    --spinner-color: white;
  }
`;
